module.exports = __webpack_public_path__ + "img/teamImg27.92e4853e.jpg";